import React, { memo } from 'react';

import { Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { PARTY_DRIVE_LABEL_VARIANTS, PartyDriveState } from '../Parties.constants';

const PartyDriveCell = ({ state, text }) => {
  const labelVariant = PARTY_DRIVE_LABEL_VARIANTS[state];

  if (labelVariant) {
    return <LabelCDS size={LabelSize.S} title={text} variant={labelVariant} />;
  }

  return (
    <Typography
      color={state === PartyDriveState.SENT ? 'text.primary' : 'text.secondary'}
      variant="regular14"
    >
      {text}
    </Typography>
  );
};

PartyDriveCell.propTypes = {
  state: PropTypes.oneOf(Object.values(PartyDriveState)).isRequired,
  text: PropTypes.string.isRequired,
};

export default memo(PartyDriveCell);
